import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from "@mui/material";
import React, {useEffect, useState} from "react";

/*
* This is a generic dialog box that can be used to confirm a delete action.
* It can also be used to confirm a create action.
* @params {boolean} open - whether the dialog is open or not
* @params {function} setOpen - function to set the open state
* @params {function} fn - function to call when the user confirms the delete
* @params {string} header - the header text
* @params {string} desc - the description text
* @params {string} confirm - the confirm button text
* @params {boolean} create - whether this is a create action or not
* @params {string} message - the message to display
 */
export default function ConfirmDeleteDialog ({open,setOpen,fn,header, desc,confirm,create,message}) {

	let headerText = header ?? "Do you really want to delete this?";
	let txt = <>Deleting this will remove the selected item and all of it's related information. <span style={{color:'red'}}>You will not be able to undo this.</span></>
	const [selectedOption,setSelectedOption]  = useState('');
	const [frm,setFrm]  = useState('');
	const option = [
		'I understand','I confirm','Delete me','Yes please'
	];

	useEffect(() => {
		let d = Math.floor(Math.random() * 4) + 1;
		setSelectedOption(option[d] || option[0]);
	}, []);


	function handleClose() {
		setOpen(false);
	}

	if(create === true && headerText) {
		txt = desc || <>You are creating a new section. Are you sure?</>;
	}

	if(create === true && !headerText) {
		txt = <>You are creating a new section. Are you sure?</>;
		headerText = "Adding content";
	}

	if(message) {
		txt = message;
	}

	return (
		<Dialog
			open={open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">
				{headerText}
			</DialogTitle>
			<DialogContent>
				<DialogContentText id="alert-dialog-description">
					{txt}
				</DialogContentText>
				{
					(confirm && selectedOption !== '') ?
						<div style={{margin:'20px 0', width:'calc(100% - 25px)'}}>
							<h5>Please verify your decision by typing "{selectedOption}". </h5>
							<input className={"form-control-search"} style={{padding:5}} placeholder={selectedOption} value={frm} onChange={(e) => setFrm(e.target.value)} />
						</div>
						: undefined
				}
			</DialogContent>
			<DialogActions>
				<Button onClick={handleClose}>No, take me back</Button>
				<Button onClick={fn} disabled={(confirm === true && frm.toLowerCase().trim() !== selectedOption.toLowerCase())}
				        autoFocus>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	)
}
